import { keyBy, isNil } from 'lodash';

export function selectedStoreCardId(state) {
  return state.selectedStoreCardId;
}

export function storeCardList(state) {
  return state.storeCardList;
}

export function storeCards(state) {
  return keyBy(state.storeCardList.filter(card => (
    !isNil(card.store_card_id)
  )), card => card.id);
}

export function publisherCards(state) {
  return keyBy(state.storeCardList.filter(card => (
    isNil(card.store_card_id)
  )), card => card.id);
}



// WEBPACK FOOTER //
// ./src/app/store-cards/store/getters.js